/**
 * The barrel has taken a set. Rounds leave it disagreeing about where they were sent.
 */

import type { Affix } from '@/sim/items/affixContract';

export const WARPED_BORE = {
  id: 'warpedBore',
  slot: 'suffix',
  field: 'damage',
  direction: -1,
  label: 'Reduced damage',
  nameWord: 'of the Warped Bore',
  ranges: {
    common: { min: 0.03, max: 0.06 },
    uncommon: { min: 0.05, max: 0.09 },
    rare: { min: 0.08, max: 0.13 },
    exotic: { min: 0.11, max: 0.17 },
  },
} as const satisfies Affix;
